<template>
	<div class="row justify-content-center no-gutters">
		<div class="form-wide">
			<form v-on:submit.prevent="onSubmit">
				<h3>Dodajte interaktivno gradivo z aktivacijsko kodo </h3>
				<table>
					<tr>
						<td>V polje vpišite aktivacijsko kodo.<span class="asterisk">*</span></td>
					</tr>
					<tr>
						<td>
							<input type="text" name="activation-code" style="width: 250px;" v-model="activationCode" placeholder="Aktivacijska koda" v-validate="'required'"  data-vv-as="aktivacijska koda"/>
							<p class="text-danger" v-if="errors.has('activation-code')" v-cloak><small>{{errors.first('activation-code')}}</small></p>
						</td>
					</tr>
					<tr v-if="spinner">
						<td>
							<spinner class="position-static"></spinner>
						</td>
					</tr>
					<tr>
						<td><button type="submit" name="submit" value="submit" class="button green">Potrdi</button></td>
					</tr>
				</table>
				<p><small><span class="text-danger">*</span> Podatek je obvezen.</small></p>
			</form>
		</div>
	</div>
</template>

<script>
	import activationSuccessPopup from './PopupActivationSuccess.vue'

	export default {
		data() {
			return {
				activationCode: null,
				spinner: false,
			}
		},
		mounted() {
			this.$nextTick(() => {
			});
		},
		methods: {
			onSubmit() {
				this.$validator.validate().then(result => {
					if (result) {
						this.spinner = true;
						axios.post('api/activation-code', {
							'activation-code': this.activationCode
						}).then((response) => {
							this.spinner = false;
							console.log(response.data);
							if (response.data.status == 'fail') {
								if (response.data.message == 'activation_code_invalid') {
									this.errors.add({
										field: 'activation-code', 
										msg: 'Neveljavna aktivacijska koda.'
									});
								} else if (response.data.message == 'activation_code_used') {
									this.errors.add({
										field: 'activation-code', 
										msg: 'Aktivacijska koda je bila že uporabljena.'
									});
								}
							} else if (response.data.status == 'success') {
								console.log('what');
								this.$root.$emit('add-popup', activationSuccessPopup, this.route('izbirka'));
							}
						}, (reason) => {
							this.errors = reason.response.data.errors;
						});
					}
					
				});
				
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ActivationCode.vue